import { DOMAIN_DEFAULT } from '@blocks/constants';
import { useSessionStore } from '@blocks/stores/session';

const useIsAuthorized = (domain: string = DOMAIN_DEFAULT): boolean => {
  const { session, customer } = useSessionStore(domain);

  return !!customer.email && !!session.user_role;
};

export default useIsAuthorized;
